import { useContext } from 'react';
import { Redirect } from 'react-router-dom';
import { HeadContext } from 'src/lib/HeadContext';

export const RIACRedirect = ({ to }: {to: string}): JSX.Element => {
  const headContext = useContext(HeadContext);
  headContext.isRedirect = true;
  headContext.redirectPath = to;
  return <Redirect to={to}/>;
};
